// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fill-table {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.fill-table .ant-spin-nested-loading,
.fill-table .ant-spin-container,
.fill-table .ant-table {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.fill-table .ant-table-container {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.fill-table .ant-table-header {
  flex: none;
}

[dir="ltr"] .fill-table .ant-table-container,[dir="ltr"] 
.fill-table .ant-table-header,[dir="ltr"] 
.fill-table .ant-table-thead > tr > th,[dir="ltr"] 
.fill-table .ant-table-thead > tr > th:first-child,[dir="ltr"] 
.fill-table .ant-table-thead > tr > th:last-child {
  border-top-left-radius: 0 !important;
}

[dir="rtl"] .fill-table .ant-table-container,[dir="rtl"] 
.fill-table .ant-table-header,[dir="rtl"] 
.fill-table .ant-table-thead > tr > th,[dir="rtl"] 
.fill-table .ant-table-thead > tr > th:first-child,[dir="rtl"] 
.fill-table .ant-table-thead > tr > th:last-child {
  border-top-right-radius: 0 !important;
}

[dir="ltr"] .fill-table .ant-table-container,[dir="ltr"] 
.fill-table .ant-table-header,[dir="ltr"] 
.fill-table .ant-table-thead > tr > th,[dir="ltr"] 
.fill-table .ant-table-thead > tr > th:first-child,[dir="ltr"] 
.fill-table .ant-table-thead > tr > th:last-child {
  border-top-right-radius: 0 !important;
}

[dir="rtl"] .fill-table .ant-table-container,[dir="rtl"] 
.fill-table .ant-table-header,[dir="rtl"] 
.fill-table .ant-table-thead > tr > th,[dir="rtl"] 
.fill-table .ant-table-thead > tr > th:first-child,[dir="rtl"] 
.fill-table .ant-table-thead > tr > th:last-child {
  border-top-left-radius: 0 !important;
}

.fill-table .ant-table-container,
.fill-table .ant-table-header,
.fill-table .ant-table-thead > tr > th,
.fill-table .ant-table-thead > tr > th:first-child,
.fill-table .ant-table-thead > tr > th:last-child {
  border-radius: 0 !important;
}

.fill-table .ant-table-body {
  height: auto !important;
  max-height: none !important;
  overflow: auto !important;
}

.fill-table .ant-table-body {
  flex: 1 1 auto;
  min-height: 0;
}

.fill-table .ant-table-body[\\:has\\(.ant-table-placeholder\\)] > table,
.fill-table .ant-table-body[\\:has\\(.ant-table-placeholder\\)] > table > .ant-table-tbody,
.fill-table .ant-table-tbody > tr.ant-table-placeholder,
.fill-table .ant-table-tbody > tr.ant-table-placeholder > td {
  height: 100%;
}

.fill-table .ant-table-body:has(.ant-table-placeholder) > table,
.fill-table .ant-table-body:has(.ant-table-placeholder) > table > .ant-table-tbody,
.fill-table .ant-table-tbody > tr.ant-table-placeholder,
.fill-table .ant-table-tbody > tr.ant-table-placeholder > td {
  height: 100%;
}

.fill-table .ant-table-placeholder .ant-table-expanded-row-fixed {
  display: flex !important;
  height: 100% !important;
}

.fill-table .ant-table-placeholder .ant-table-expanded-row-fixed {
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/shares/FillTable/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;EAME;AAEF;;AARA;;;;;EAME;AAEF;;AARA;;;;;EAOE;AACF;;AARA;;;;;EAOE;AACF;;AARA;;;;;EAKE,2BAA2B;AAG7B;;AAEA;EAEE,uBAAuB;EACvB,2BAA2B;EAE3B,yBAAyB;AAC3B;;AANA;EACE,cAAc;EAGd,aAAa;AAEf;;AAEA;;;;EAIE,YAAY;AACd;;AALA;;;;EAIE,YAAY;AACd;;AAEA;EACE,wBAAwB;EAGxB,uBAAuB;AACzB;;AALA;EAEE,mBAAmB;EACnB,uBAAuB;AAEzB","sourcesContent":[".fill-table {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.fill-table .ant-spin-nested-loading,\n.fill-table .ant-spin-container,\n.fill-table .ant-table {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.fill-table .ant-table-container {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.fill-table .ant-table-header {\n  flex: none;\n}\n\n.fill-table .ant-table-container,\n.fill-table .ant-table-header,\n.fill-table .ant-table-thead > tr > th,\n.fill-table .ant-table-thead > tr > th:first-child,\n.fill-table .ant-table-thead > tr > th:last-child {\n  border-radius: 0 !important;\n  border-start-start-radius: 0 !important;\n  border-start-end-radius: 0 !important;\n}\n\n.fill-table .ant-table-body {\n  flex: 1 1 auto;\n  height: auto !important;\n  max-height: none !important;\n  min-height: 0;\n  overflow: auto !important;\n}\n\n.fill-table .ant-table-body:has(.ant-table-placeholder) > table,\n.fill-table .ant-table-body:has(.ant-table-placeholder) > table > .ant-table-tbody,\n.fill-table .ant-table-tbody > tr.ant-table-placeholder,\n.fill-table .ant-table-tbody > tr.ant-table-placeholder > td {\n  height: 100%;\n}\n\n.fill-table .ant-table-placeholder .ant-table-expanded-row-fixed {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  height: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
